import React, { useState } from "react";
import {
  FaBalanceScale,
  FaCalculator,
  FaShieldAlt,
  FaExclamationTriangle,
  FaUsers,
} from "react-icons/fa";
import Swal from "sweetalert2";

export const LeadMagnet = (props) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization_name: "",
    template: "",
  });

  const [loading, setLoading] = useState(false); // 🔥 SPINNER STATE

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.template) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill out all required fields.",
      });
      return;
    }

    setLoading(true); // 🔥 START LOADING

    try {
      const response = await fetch(
        "https://admin.businessunbuzzed.com/api/free-assessment",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Check your email for free assessment template.",
          confirmButtonColor: "#3085d6",
        });

        setFormData({
          name: "",
          email: "",
          organization_name: "",
          template: "",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Unable to submit form. Please check your connection.",
      });
    }

    setLoading(false); // 🔥 STOP LOADING
  };

  return (
    <div id="lead-magnet" className="lead-section py-5">
      <div className="container">
        <div
          className="section-title text-center mb-5"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <h2>{props.data ? props.data.title : "Loading..."}</h2>
          <p>{props.data ? props.data.subtitle : "Loading..."}</p>
        </div>

        {/* ICONS */}
        <div className="row text-center icon-grid mb-5">
          <div className="col-md-2 col-sm-4 col-xs-6 mb-3" data-aos="zoom-in" data-aos-delay="100">
            <FaBalanceScale size={40} className="icon-style" />
            <p>Conflict of Interest</p>
          </div>
          <div className="col-md-2 col-sm-4 col-xs-6 mb-3" data-aos="zoom-in" data-aos-delay="200">
            <FaCalculator size={40} className="icon-style" />
            <p>Financial Management</p>
          </div>
          <div className="col-md-2 col-sm-4 col-xs-6 mb-3" data-aos="zoom-in" data-aos-delay="300">
            <FaShieldAlt size={40} className="icon-style" />
            <p>Risk Management</p>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-6 mb-3" data-aos="zoom-in" data-aos-delay="400">
            <FaExclamationTriangle size={40} className="icon-style" />
            <p>Emergency Response</p>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-6 mb-3" data-aos="zoom-in" data-aos-delay="500">
            <FaUsers size={40} className="icon-style" />
            <p>Volunteer Management</p>
          </div>
        </div>

        {/* FORM */}
        <div className="row justify-content-center">
          <div className="col-md-8" data-aos="fade-up" data-aos-duration="1200">
            <div className="lead-form glass-effect p-4 rounded shadow-lg" style={{ position: "relative" }}>

              {/* 🔥 SPINNER OVERLAY */}
              {loading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.2)",
                    backdropFilter: "blur(3px)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                    borderRadius: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "45px",
                      height: "45px",
                      border: "5px solid #fff",
                      borderTop: "5px solid transparent",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  ></div>

                  <style>
                    {`
                      @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                      }
                    `}
                  </style>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name"
                    className="form-control transparent-input"
                    disabled={loading}
                  />
                </div>

                <div className="form-group mb-3">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Address"
                    className="form-control transparent-input"
                    disabled={loading}
                  />
                </div>

                <div className="form-group mb-3">
                  <input
                    type="text"
                    name="organization_name"
                    value={formData.organization_name}
                    onChange={handleChange}
                    placeholder="Organisation Name (optional)"
                    className="form-control transparent-input"
                    disabled={loading}
                  />
                </div>

                <div className="form-group mb-3">
                  <select
                    name="template"
                    value={formData.template}
                    onChange={handleChange}
                    className="form-control transparent-input"
                    disabled={loading}
                  >
                    <option value="">Select Policy Template</option>
                    <option>Conflict of Interest</option>
                    <option>Financial Management</option>
                    <option>Risk Management</option>
                    <option>Emergency Response</option>
                    <option>Volunteer Management</option>
                  </select>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary w-100 py-2"
                  style={{ opacity: loading ? 0.6 : 1 }}
                >
                  GET YOUR FREE ASSESSMENT + TEMPLATE
                </button>
              </form>

              <p className="form-note text-center mt-3 text-white-50">
                Instant PDF Download • FREE $97 Value Policy Template
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
